// eslint-disable-next-line import/no-unresolved
import { useRegisterSW } from 'virtual:pwa-register/vue';

useRegisterSW({
    onRegisteredSW: (_swScriptUrl, registration) => {
        if (registration) {
            setInterval(() => {
                console.debug('Checking for updates');
                registration.update();
            }, 5000);
        }
    },
});
